import React from 'react'

import Title from './Title'
import Headers from './Headers'
import Response from './Response'

import { withMicrocopy } from '~contexts/MicrocopyContext'

export const Output = ({ 
  explorer,
  microcopy
}) => (
  <>
    { explorer?.enabled && 
      (explorer.renderedResponse || explorer.renderedHeaders) && (
      <section>
        <Title explorer={explorer} microcopy={microcopy} />
        { explorer.renderedHeaders && <Headers explorer={explorer} microcopy={microcopy} /> }
        { explorer.renderedResponse && <Response explorer={explorer} microcopy={microcopy} /> }
      </section>
    )}
  </>
)

export default withMicrocopy(Output)